import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "time-edit-view" }
const _hoisted_2 = { class: "row v-center gap" }
const _hoisted_3 = { class: "fill row center h2" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "item-box col" }
const _hoisted_6 = { class: "activity-title" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "fee-notice"
}
const _hoisted_9 = { class: "row v-center gap right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "close-button link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'OrderTime' })))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "gg-close" }, null, -1)
      ])),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.next === 'OrderTimeSwap' ? 'Swap activity' : 'Edit booking'), 1)
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.type), 1),
        _createElementVNode("div", {
          class: "activity-time",
          innerHTML: _ctx.copy
        }, null, 8, _hoisted_7),
        (_ctx.feeAmount > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createTextVNode(" * A fee of ", -1)),
              _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.feeAmount.toFixed(2)), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.feeTypeLabel) + " will be charged. ", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "separator" }, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "blue",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onNext()))
        }, _toDisplayString(_ctx.canEdit ? 'Agree and continue' : 'Ok'), 1)
      ])
    ])
  ]))
}